import "./App.css";
import Todo from "./components/Todo";

function App() {
  return (
    <div className="bg-dark">
      <div className="container text-center">
        <Todo />
      </div>
    </div>
  );
}

export default App;
